package com.evoapps.evoshift.widget

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.toArgb
import com.evoapps.evoshift.domain.model.Appearance
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.Palettes

/**
 * SH-200: the home-screen widget's colours for the appearance picked in the app (SH-196): the
 * base as the background, the accent's metallic tone (the palette's "on the dark surfaces" one)
 * for titles and highlights, cream text and cream at 70% for secondary text. Granat + Złoto is the
 * widget's look before SH-200, value for value. WidgetPaletteTest checks every pair at 4.5:1 on all
 * nine combinations. Written into the snapshot ([ShiftWidgetSnapshot.colors]) so the Android and
 * iOS widgets draw the same colours.
 */
object WidgetPalette {
    /** Secondary text: cream at 70%. */
    val MutedCream = Color(0xB3FDFBF7)

    data class Colors(val background: Color, val accent: Color, val text: Color, val muted: Color)

    fun of(appearance: Appearance): Colors {
        val palette = Palettes.of(appearance)
        return Colors(background = palette.base.base, accent = palette.accent.metallic, text = Cream, muted = MutedCream)
    }

    fun snapshotColors(appearance: Appearance): WidgetColors = of(appearance).let {
        WidgetColors(
            appearance = appearance.stored,
            background = it.background.hex(), accent = it.accent.hex(), text = it.text.hex(), muted = it.muted.hex()
        )
    }

    /** "#AARRGGBB". */
    fun Color.hex(): String = "#" + (toArgb().toLong() and 0xFFFFFFFFL).toString(16).padStart(8, '0').uppercase()
}
